import { render, staticRenderFns } from "./discountJournal.vue?vue&type=template&id=c7d3ee3c&"
import script from "./discountJournal.vue?vue&type=script&lang=js&"
export * from "./discountJournal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports